import Head from 'next/head'

import SearchApp from 'app/AssessmentPage/Search'
import { IS_ASSESSMENT_REVAMP_ENABLED } from 'configs/toggle'

export async function getServerSideProps() {
  if (!IS_ASSESSMENT_REVAMP_ENABLED) {
    return {
      redirect: {
        destination: '/assessment/litnum',
        permanent: false,
      },
    }
  }
  return {
    props: {},
  }
}

const AssesmentSelect = () => {
  return (
    <>
      <Head>
        <title>Cari Asesmen</title>
      </Head>
      <SearchApp />
    </>
  )
}

export default AssesmentSelect
